import React, {useState} from 'react'

function EditPartnerForm({ partner, handleUpdatePartner }) {
    const [name, setName] = useState(partner.name);
    const [serviceId, setServiceId] = useState(partner.serviceId);

    
  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedPartner = {
      name,
      serviceId,
    };
    handleUpdatePartner(updatedPartner);
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label> Nom</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="form-group">
            <label htmlFor="type-carte">Service:</label>
            <select id="service-id" name="serviceId" value={serviceId} onChange={(e) => setServiceId(e.target.value)}>
                <option value="">Laboratoire</option>
                    <option value="bronze">generaliste</option>
                    <option value="argent">Prise de sang</option>
            </select>
        </div>
      </div>
      <div className="flex justify-end">
        <button type="submit">Mettre à jour</button>
      </div>
    </form>
  )
}

export default EditPartnerForm